/* Birch & Brass — "Goes with" hydration. The Search & Discovery complementary picks are not readable in Liquid,
   so both the product-page strip and the cart row fetch /recommendations/products?intent=complementary and render here. */
import { CartAddEvent } from '@theme/events';

const money = (c) => { const d = c / 100; return '$' + (Number.isInteger(d) ? d.toFixed(0) : d.toFixed(2)); };
const NOUN = /^(lamps?|lights?|mirrors?|chandeliers?|sconces?|vases?|trees?|art|cabinets?|pendants?|pillows?|baskets?|candles?|trays?|bowls?|plants?|rugs?|shelf|shelves|tables?|stools?|chairs?|clocks?|planters?|holders?|sets?|nightstands?|sculptures?)$/i;
const shortTitle = (t) => { const w = t.split(',')[0].split(' with ')[0].split(' for ')[0].split(' - ')[0].trim().split(' '); if (w.length <= 6) return w.join(' '); let cut = 0; w.slice(0, 7).forEach((x, i) => { if (NOUN.test(x.replace(/[^a-z]/gi, ''))) cut = i + 1; }); return (cut ? w.slice(0, cut) : w.slice(0, 6)).join(' '); };
const esc = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
const DENY = /bath|vanity|cabinet|storage|hardware|utility|cleaning|faux|artificial|plant|tree|rug|doormat|medicine/i;
const allowed = (p) => !DENY.test((p.type || p.product_type || '') + ' ' + p.title);
const singularType = (t) => { t = (t || '').trim().toLowerCase(); if (!t) return 'this piece'; t = t.replace(/\s*&.*$/, '').replace(/ies$/, 'y').replace(/s$/, ''); return 'this ' + t; };
const recUrl = () => (window.Theme && Theme.routes && Theme.routes.product_recommendations_url) || '/recommendations/products';
const img = (p, w) => (p.featured_image || (p.images && p.images[0]) || '').replace(/(\.[a-z]+)(\?.*)?$/i, `_${w}x$1$2`);

async function fetchPicks(productId, exclude, limit) {
  try {
    const r = await fetch(`${recUrl()}.json?product_id=${productId}&intent=complementary&limit=${limit + exclude.length}`, { headers: { Accept: 'application/json' } });
    if (!r.ok) return [];
    const j = await r.json();
    return (j.products || []).filter((p) => p.available && !exclude.includes(p.id) && allowed(p)).slice(0, limit);
  } catch (e) { return []; }
}

async function addToCart(variantId) {
  const ids = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
  const r = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ids.join(',') }) });
  const res = await r.json();
  if (res.status) throw new Error(res.message || 'cart');
  document.dispatchEvent(new CartAddEvent(res, 'bb-goes', { source: 'bb-goes', sections: res.sections }));
  if (!ids.length) window.location.reload();
}

/* ---- product page strip ---- */
async function hydrateStrip() {
  const form = document.querySelector('[data-goes][data-product-id]:not([data-hydrated])');
  if (!form) return;
  form.dataset.hydrated = '1';
  const exclude = [Number(form.dataset.productId)];
  const picks = await fetchPicks(form.dataset.productId, exclude, Number(form.dataset.count || 3));
  if (picks.length < 2) { const sec = form.closest('.bb-goes'); if (sec) sec.hidden = true; return; }
  const host = form.querySelector('[data-goes-picks]');
  if (!host) return;
  host.innerHTML = picks.map((p) => {
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const single = p.variants.length === 1 && (p.options.length === 0 || p.options[0] === 'Title');
    return `<span class="bb-goes__plus" aria-hidden="true">+</span>
<label class="bb-goes__item">
  <span class="bb-goes__check"><input type="checkbox" checked name="pick" data-price="${v.price}" data-id="${v.id}"><span class="bb-goes__box" aria-hidden="true"></span></span>
  <a class="bb-goes__ph" href="${esc(p.url)}"><img src="${esc(img(p, 500))}" alt="${esc(p.title)}" loading="lazy">${p.images && p.images[1] ? `<img class="alt" src="${esc(p.images[1].replace(/(\.[a-z]+)(\?.*)?$/i, '_500x$1$2'))}" alt="" loading="lazy">` : ''}</a>
  <span class="bb-goes__meta"><a class="bb-goes__nm" href="${esc(p.url)}">${esc(shortTitle(p.title))}</a><span class="bb-goes__pr">${p.price_varies ? 'from ' : ''}${money(v.price)}</span>${single ? '' : `<span class="bb-goes__var">${esc(v.title)}</span>`}</span>
</label>`;
  }).join('');
  form.dispatchEvent(new CustomEvent('bb-goes:rebound'));
}

/* ---- cart row ---- */
async function hydrateCart() {
  for (const box of document.querySelectorAll('.bb-cgw[data-cart-items]')) {
    const list0 = box.querySelector('.bb-cgw__list');
    if (box.dataset.busy === '1' || (box.dataset.hydrated === '1' && list0 && list0.children.length)) continue;
    box.dataset.busy = '1'; box.dataset.hydrated = '1';
    const exclude = (box.dataset.inCart || '').split(',').filter(Boolean).map(Number);
    const entries = (box.dataset.cartItems || '').split('|').map((s) => { const i = s.indexOf(':'); return [s.slice(0, i), s.slice(i + 1)]; }).filter((e) => e[0]);
    let picks = [], name = '';
    for (const [pid, ptype] of entries) {
      picks = await fetchPicks(pid, exclude, 3);
      if (picks.length >= 2) { name = singularType(ptype); break; }
      picks = [];
    }
    const list = box.querySelector('.bb-cgw__list');
    if (!picks.length || !list) { box.hidden = true; box.dataset.busy = '0'; continue; }
    const nameEl = box.querySelector('[data-cgw-name]'); if (nameEl) nameEl.textContent = name;
    list.innerHTML = picks.map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const single = p.variants.length === 1 && (p.options.length === 0 || p.options[0] === 'Title');
      return `<li class="bb-cgw__item">
  <a class="bb-cgw__ph" href="${esc(p.url)}"><img src="${esc((p.images && p.images[1]) ? p.images[1].replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : img(p, 160))}" alt="${esc(p.title)}" width="56" height="68" loading="lazy"></a>
  <span class="bb-cgw__meta"><a class="bb-cgw__nm" href="${esc(p.url)}">${esc(shortTitle(p.title))}</a><span class="bb-cgw__pr">${p.price_varies ? 'from ' : ''}${money(v.price)}</span></span>
  ${single ? `<button type="button" class="bb-cgw__add" data-variant-id="${v.id}" aria-label="Add ${esc(p.title)} to cart">+</button>` : `<a class="bb-cgw__add" href="${esc(p.url)}" aria-label="Choose options for ${esc(p.title)}">→</a>`}
</li>`;
    }).join('');
    box.hidden = false; box.dataset.busy = '0';
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bb-cgw__add[data-variant-id]');
  if (!btn) return;
  e.preventDefault(); btn.disabled = true;
  try { await addToCart(btn.dataset.variantId); } catch (err) { btn.disabled = false; }
});

const run = () => { hydrateStrip(); hydrateCart(); };
run();
let pending = null;
const schedule = () => { clearTimeout(pending); pending = setTimeout(hydrateCart, 80); };
document.addEventListener('cart:update', schedule);
document.addEventListener('dialog:open', schedule);
new MutationObserver((muts) => { for (const m of muts) { const t = m.target; if (t.nodeType === 1 && (t.closest?.('.bb-cgw, .cart-drawer__dialog, cart-items-component, .cart-summary') )) { schedule(); return; } for (const n of m.addedNodes) { if (n.nodeType === 1 && (n.matches?.('.bb-cgw') || n.querySelector?.('.bb-cgw'))) { schedule(); return; } } } }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'data-hydrated'] });
